import React from 'react'
import { Box, Chip, Stack, TextField, Typography } from '@mui/material'
import FolderIcon from '@mui/icons-material/Folder'
import { BatchRegenerateState, blueBoxSx, myTablesPath } from './regenerateShared'

const PREVIEW_COUNT = 10

/** Step "Name the new set": prefix (required), suffix (optional), and where
 *  the tables go, with the first new names updating as the user types. */
const StepName: React.FC<{ batch: BatchRegenerateState }> = ({ batch }) => {
  const shown = batch.sourceTables.slice(0, PREVIEW_COUNT)
  const more = batch.sourceTables.length - shown.length
  return (
    <Box>
      <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
        Each table has to have a unique name. What prefix would you like to give these tables?
      </Typography>
      <Box sx={{ ...blueBoxSx, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
          <TextField
            label="Prefix"
            required
            autoFocus
            value={batch.prefix}
            onChange={e => batch.setPrefix(e.target.value)}
            placeholder="e.g. MG_"
            helperText="Required"
            size="small"
            sx={{ flex: 1, backgroundColor: 'background.paper' }}
          />
          <TextField
            label="Suffix (optional)"
            value={batch.suffix}
            onChange={e => batch.setSuffix(e.target.value)}
            placeholder="e.g. _v2"
            helperText="Added after each name"
            size="small"
            sx={{ flex: 1, backgroundColor: 'background.paper' }}
          />
        </Stack>
        <Stack direction="row" spacing={1} alignItems="center">
          <FolderIcon fontSize="small" sx={{ color: 'info.main' }} />
          <Typography variant="body2" sx={{ fontWeight: 600 }}>
            Saving to: {myTablesPath(batch.destinationFolder)}
          </Typography>
        </Stack>
      </Box>

      <Typography variant="subtitle2" sx={{ mt: 3, mb: 1, color: 'text.secondary' }}>
        New table names
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
        {shown.map(t => (
          <Chip key={t.path} label={batch.newTableName(t.name)} size="small" variant="outlined" color="info" />
        ))}
      </Box>
      {more > 0 && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
          and {more.toLocaleString()} more
        </Typography>
      )}
    </Box>
  )
}

export default StepName
